export const DATA_TYPE_ARRAY = "array";
export const DATA_TYPE_DATE = "date";
export const DATA_TYPE_FLOAT = "float";
export const DATA_TYPE_INTEGER = "integer";
export const DATA_TYPE_INTEGER_ARRAY = "integer[]";
export const DATA_TYPE_STRING = "string";
export const DATA_TYPE_STRING_ARRAY = "string[]";
export const DETAIL_VIN = "VIN";
export const DETAIL_MANUFACTURER_NAME = "Manufacturer";
export const DETAIL_MANUFACTURER_ADDRESS = "Manufacturer Address";
export const DETAIL_PRODUCT_TYPE = "Product Type";
export const DETAIL_MAKE = "Make";
export const DETAIL_MODEL = "Model";
export const DETAIL_VEHICLE_SPEC = "Vehicle Specification";
export const DETAIL_MODEL_YEAR = "Model Year";
export const DETAIL_MARKET = "Market";
export const DETAIL_SERIES = "Series";
export const DETAIL_TRIM = "Trim";
export const DETAIL_EU_APPROVAL = "Vehicle Type Approval";
export const DETAIL_EU_APPROVAL_SHORT = "Vehicle Type Approval (short)";
export const DETAIL_BODY = "Body";
export const DETAIL_DRIVE = "Drive";
export const DETAIL_COLOR = "Color";
export const DETAIL_COLOR_INTERIOR = "Color (interior)";
export const DETAIL_INTERIOR_FABRIC = "Interior Fabric";
export const DETAIL_NUMBER_SEATS = "Number of Seats";
export const DETAIL_NUMBER_SEAT_ROWS = "Number of Seat Rows";
export const DETAIL_NUMBER_DOORS = "Number of Doors";
export const DETAIL_NUMBER_AIRBAGS = "Number of Airbags";
export const DETAIL_NUMBER_AXLES = "Number of Axles";
export const DETAIL_NUMBER_WHEELS = "Number Wheels";
export const DETAIL_STEERING = "Steering";
export const DETAIL_STEERING_TYPE = "Steering Type";
export const DETAIL_POWER_STEERING = "Power Steering";
export const DETAIL_LENGTH_MM = "Length (mm)";
export const DETAIL_WIDTH_MM = "Width (mm)";
export const DETAIL_WIDTH_INCLUDING_MIRRORS_MM = "Width including mirrors (mm)";
export const DETAIL_WIDTH_MIRRORS_FOLDED_MM = "Width mirrors folded (mm)";
export const DETAIL_HEIGHT_MM = "Height (mm)";
export const DETAIL_RIDE_HEIGHT_MM = "Ride Height (mm)";
export const DETAIL_WEIGHT_EMPTY_KG = "Weight Empty (kg)";
export const DETAIL_APPROACH_ANGLE_DEG = "Approach Angle (°)";
export const DETAIL_DEPARTURE_ANGLE_DEG = "Departure Angle (°)";
export const DETAIL_RAMP_ANGLE_DEG = "Ramp Angle (°)";
export const DETAIL_MAX_WEIGHT_KG = "Max Weight (kg)";
export const DETAIL_MIN_LUGGAGE_L = "Minimum Trunk Capacity (l)";
export const DETAIL_MAX_LUGGAGE_L = "Maximum Trunk Capacity (l)";
export const DETAIL_TRACK_FRONT_MM = "Track Front (mm)";
export const DETAIL_TRACK_REAR_MM = "Track Rear (mm)";
export const DETAIL_WHEEL_BASE_MM = "Wheelbase (mm)";
export const DETAIL_WHEEL_BASE_MM_ARR = "Wheelbase Array (mm)";
export const DETAIL_WHEEL_SIZE = "Wheel Size";
export const DETAIL_WHEEL_SIZE_ARR = "Wheel Size Array";
export const DETAIL_WHEEL_RIMS_SIZE = "Wheel Rims Size";
export const DETAIL_WHEEL_RIMS_SIZE_ARR = "Wheel Rims Size Array";
export const DETAIL_FRONT_BREAKS = "Front Breaks";
export const DETAIL_FRONT_BRAKES = "Front Brakes";
export const DETAIL_REAR_BREAKS = "Rear Breaks";
export const DETAIL_REAR_BRAKES = "Rear Brakes";
export const DETAIL_BRAKE_SYSTEM = "Brake System";
export const DETAIL_SUSPENSION = "Suspension";
export const DETAIL_FRONT_SUSPENSION = "Front Suspension";
export const DETAIL_REAR_SUSPENSION = "Rear Suspension";
export const DETAIL_FRONT_OVERHANG_MM = "Front Overhang (mm)";
export const DETAIL_REAR_OVERHANG_MM = "Rear Overhang (mm)";
export const DETAIL_DRAG_COEFFICIENT = "Drag Coefficient";
export const DETAIL_MAX_ROOF_LOAD_KG = "Max roof load (kg)";
export const DETAIL_PERMITTED_TRAILER_LOAD_WITH_BRAKES_12_PERCENT_KG = "Permitted trailer load with brakes 12% (kg)";
export const DETAIL_PERMITTED_TRAILER_LOAD_WITH_BRAKES_8_PERCENT_KG = "Permitted trailer load with brakes 8% (kg)";
export const DETAIL_PERMITTED_TRAILER_LOAD_WITHOUT_BRAKES_KG = "Permitted trailer load without brakes (kg)";
export const DETAIL_PERMITTED_TOWBAR_DOWNLOAD_KG = "Permitted towbar download (kg)";
export const DETAIL_FUEL_TYPE_PRIMARY = "Fuel Type - Primary";
export const DETAIL_FUEL_TYPE_SECONDARY = "Fuel Type - Secondary";
export const DETAIL_FUEL_SYSTEM = "Fuel System";
export const DETAIL_FUEL_CAPACITY = "Fuel Capacity (l)";
export const DETAIL_FUEL_CONSUMPTION_COMBINED_L_KM = "Fuel Consumption Combined (l/100km)";
export const DETAIL_FUEL_CONSUMPTION_EXTRA_URBAN_L_KM = "Fuel Consumption Extra Urban (l/100km)";
export const DETAIL_FUEL_CONSUMPTION_URBAN_L_KM = "Fuel Consumption Urban (l/100km)";
export const DETAIL_FUEL_CONSUMPTION_URBAN_L_KM_WLTP = "Fuel Consumption Urban (l/100km) (WLTP)";
export const DETAIL_ENGINE_MANUFACTURER = "Engine Manufacturer";
export const DETAIL_ENGINE_FULL = "Engine (full)";
export const DETAIL_ENGINE_DISPLACEMENT_CCM = "Engine Displacement (ccm)";
export const DETAIL_ENGINE_POWER_HP = "Engine Power (HP)";
export const DETAIL_ENGINE_POWER_KW = "Engine Power (kW)";
export const DETAIL_ENGINE_RPM = "Engine RPM";
export const DETAIL_ENGINE_TYPE = "Engine Type";
export const DETAIL_ENGINE_CYLINDERS = "Engine Cylinders";
export const DETAIL_ENGINE_CYLINDERS_POSITION = "Engine Cylinders Position";
export const DETAIL_ENGINE_CYLINDER_BORE = "Engine Cylinder Bore (mm)";
export const DETAIL_ENGINE_VALVES_PER_CYLINDER = "Valves per Cylinder";
export const DETAIL_ENGINE_VALVE_TRAIN = "Valve Train";
export const DETAIL_ENGINE_POSITION = "Engine Position";
export const DETAIL_ENGINE_TORQUE = "Engine Torque (RPM)";
export const DETAIL_ENGINE_COMPRESSION_RATIO = "Engine Compression Ratio";
export const DETAIL_ENGINE_MODEL = "Engine Model";
export const DETAIL_ENGINE_CODE = "Engine Code";
export const DETAIL_ENGINE_MAX_SPEED_RPM = "Engine Max Speed (rpm)";
export const DETAIL_ENGINE_OIL_CAPACITY_L = "Engine Oil Capacity (l)";
export const DETAIL_ENGINE_COOLANT_L = "Engine Coolant (l)";
export const DETAIL_ENGINE_STROKE = "Engine Stroke (mm)";
export const DETAIL_ENGINE_TURBINE = "Engine Turbine";
export const DETAIL_TRANSMISSION = "Transmission";
export const DETAIL_TRANSMISSION_FULL = "Transmission (full)";
export const DETAIL_NUMBER_GEARS = "Number of Gears";
export const DETAIL_BATTERY_INFO = "Battery Info";
export const DETAIL_BATTERY_TYPE = "Battery Type";
export const DETAIL_AXLE_RATIO = "Axle Ratio";
export const DETAIL_MAX_SPEED_KMH = "Max Speed (km/h)";
export const DETAIL_ACCELERATION_0_TO_100_KMH = "Acceleration 0-100 km/h (s)";
export const DETAIL_MIN_TURNING_CIRCLE_M = "Minimum Turning Circle (m)";
export const DETAIL_ELECTRIC_MOTOR_POWER_HP = "Electric Motor Power (HP)";
export const DETAIL_ELECTRIC_MOTOR_POWER_KW = "Electric Motor Power (kW)";
export const DETAIL_ELECTRIC_MOTOR_RPM = "Electric Motor RPM";
export const DETAIL_ELECTRIC_MOTOR_TORQUE_NM = "Electric Motor Torque (Nm)";
export const DETAIL_ELECTRIC_CONSUMPTION_URBAN_KW_KM = "Electric Consumption (kWh/100km)";
export const DETAIL_ELECTRIC_CONSUMPTION_URBAN_KW_KM_WLTP = "Electric Consumption (kWh/100km) (WLTP)";
export const DETAIL_ELECTRIC_RANGE_FROM = "Electric Range From (km)";
export const DETAIL_ELECTRIC_RANGE_TO = "Electric Range To (km)";
export const DETAIL_ELECTRIC_RANGE_FROM_WLTP = "Electric Range From (km) (WLTP)";
export const DETAIL_ELECTRIC_RANGE_TO_WLTP = "Electric Range To (km) (WLTP)";
export const DETAIL_PLANT_COMPANY_NAME = "Plant Company";
export const DETAIL_PLANT_COUNTRY = "Plant Country";
export const DETAIL_PLANT_STATE = "Plant State";
export const DETAIL_PLANT_CITY = "Plant City";
export const DETAIL_AIR_CONDITIONING = "Air Conditioning";
export const DETAIL_ABS = "ABS";
export const DETAIL_EQUIPMENT = "Equipment";
export const DETAIL_DATE_MANUFACTURED = "Made";
export const DETAIL_DATE_REGISTERED = "Registered";
export const DETAIL_YEAR_PRODUCTION_STARTED = "Production Started";
export const DETAIL_YEAR_PRODUCTION_STOPPED = "Production Stopped";
export const DETAIL_ODOMETER_KM = "Odometer (km)";
export const DETAIL_EMISSION_STANDARD = "Emission Standard";
export const DETAIL_CO2_EMISSION = "CO2 Emission (g/km)";
export const DETAIL_CO2_EMISSION_WLTP = "CO2 Emission (g/km) (WLTP)";
export const DETAIL_CO2_EMISSION_AVG = "Average CO2 Emission (g/km)";
export const DETAIL_CHECK_DIGIT = "Check Digit";
export const DETAIL_CHECK_DIGIT_VALID = "Valid Check Digit";
export const DETAIL_CHECK_DIGIT_VALIDITY = "Check Digit Validity";
export const DETAIL_SEQUENTIAL_NUMBER = "Sequential Number";
export const DETAIL_PRICE = "Price";
export const DETAIL_PRICE_ORIGINAL = "Price Original";
export const DETAIL_PRICE_CURRENCY = "Price Currency";
export const DETAIL_PRICE_ARRAY = "Price";
export const DETAIL_ODOMETER_KM_ARRAY = "Odometer (km)";
export const DETAIL_ENUM_MAKE = "Make ID";
export const DETAIL_ENUM_MODEL = "Model ID";
export const DETAIL_ENUM_BODY = "Body ID";
export const DETAIL_ENUM_COLOR = "Color ID";
export const DETAIL_ENUM_DRIVE = "Drive ID";
export const DETAIL_ENUM_FUEL_TYPE_PRIMARY = "Fuel Type - Primary ID";
export const DETAIL_ENUM_FUEL_TYPE_SECONDARY = "Fuel Type - Secondary ID";
export const DETAIL_ENUM_PRODUCT_TYPE = "Product Type ID";
export const DETAIL_ENUM_TRANSMISSION = "Transmission ID";
export const DETAIL_ENUM_VEHICLE_IDENTIFICATION = "Vehicle ID";
export const CATEGORY_WMI = "wmi";
export const CATEGORY_VDS = "vds";
export const CATEGORY_CHECK_DIGIT = "checkDigit";
export const CATEGORY_MODEL_YEAR = "modelYear";
export const CATEGORY_PLANT_CODE = "plantCode";
export const CATEGORY_SEQUENTIAL_NUMBER = "sequentialNumber";
export const GROUP_BASIC_VEHICLE_IDENTIFICATION = "Basic Vehicle Identification";
export const GROUP_MANUFACTURER = "Manufacturer";
export const GROUP_DATES = "Dates";
export const GROUP_ENGINE = "Engine";
export const GROUP_ENGINE_ADVANCED = "Engine Advanced";
export const GROUP_VEHICLE_SETUP = "Vehicle Setup";
export const GROUP_MEASURES_DIMENSIONS = "Measures/Dimensions";
export const GROUP_OPTIONS_EQIUPMENT = "Options/Equipment";
export const GROUP_VIN_SPECIFIC = "VIN Specific";
export const GROUP_VEHICLE_HISTORY = "Odometer Reading";
export const PS_TO_KW_RATIO = 0.7354988;
export const HP_TO_KW_RATIO = 0.745699872;
export const IN_TO_MM_RATIO = 25.4;